import { Button, Modal } from "@mui/material";

const ChangePasswordInfoSmall = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        zIndex: 9999,
        outline: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          maxWidth: "690px",
          width: "100%",
          overflow: "auto",
          borderRadius: "var(--wrapperBorderRadius)",
          outline: "none",
          maxHeight: "90vh",
          padding: "20px",
        }}
      >
        {/* <figure
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "var(--pastelBlue)",
          }}
        >
          <img
            src="/images/heros/heros.png"
            alt="Hadenka"
            style={{ width: "100%" }}
          />
        </figure> */}
        <div
          style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap)",
          }}
        >

          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu süre zarfı içerisinde LÜTFEN ETSY BAĞLANTINIZI IYZISHIP ile koparmayınız.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bilgilerinize
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu vesileyle Kurban Bayramınızın Mübarek olmasını dileriz. Hayırlı Bayramlar…
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Bilgilerinize…
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Saygılarımızla,
          </p> */}
          <h2
            style={{
              fontSize: "22px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            Planlı Bakım Duyurusu ⚠️
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            11.09.2025 tarihinde (çarşambayı perşembeye bağlayan gece) 00:00-02:00 arasında sistemlerimizde planlı bakım çalışması yapılacaktır.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Çalışma süresince, web sitemiz ve müşteri panelimizde belli aralıklarla kesintiler öngörülmektedir.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Anlayışınız için teşekkür ederiz.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Saygılarımızla,
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Hadenka
          </p>
          <Button className="iyzi-button-blue" onClick={handleClose}>
            Tamam
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangePasswordInfoSmall;
